import { useLogisticCartFilters } from 'hooks/useLogisticCartFilters'
import { logisticCartApi } from 'redux/services/logistic-cart'

import { AppStatistics } from 'components/AppStatistics/AppStatistics'

export function Statistics() {
  const { params } = useLogisticCartFilters()

  const { data, isSuccess } =
    logisticCartApi.useLogisticCartStatisticsQuery(params)

  if (isSuccess) {
    return <AppStatistics list={data} />
  }
  return null
}
